import { IndicatorDot } from "./internals/components/IndicatorDot";
import { IndicatorIcon } from "./internals/components/IndicatorIcon";

interface TypingIndicatorProps {
  size?: number;
}

export const TypingIndicator = ({ size = 3 }: TypingIndicatorProps) => {
  return (
    <IndicatorIcon role={"progressbar"}>
      <IndicatorDot size={size} />
      <IndicatorDot size={size} />
      <IndicatorDot size={size} />
    </IndicatorIcon>
  );
};
